import { inject } from 'vue';
import {
  TokensProviderResponse,
  TokensProviderSymbol
} from '@/providers/veFlakeTokens.provider';

const defaultProviderResponse = {} as TokensProviderResponse;

/**
 * useTokens Composable
 * Interface to all token static and dynamic metatdata.
 */
export default function useVeFlakeTokens(): TokensProviderResponse {
  return inject(TokensProviderSymbol, defaultProviderResponse);
}
